const $ = jQuery;
document.addEventListener("DOMContentLoaded", (event) => {
	const resourceCards = document.querySelectorAll(".resource-card");

	if (resourceCards && resourceCards.length > 0) {
		resourceCards.forEach((card) => {
			const heading = card.querySelector(".et_pb_module_header");
			const imageSpan = card.querySelector(".et_pb_image_wrap");

			if (!heading && !imageSpan) return;

			imageSpan.after(heading);
		});
	}
});
